import z from 'zod'
import { FarmDto } from '../../domain/dtos/Farm.dto'

export const FarmSchema = z
	.object({
		nome: z.string(),
		id: z.string(),
	})
	.transform((data) => {
		return {
			name: data.nome,
			id: data.id,
		} as FarmDto
	})
